import * as React from "react";

import { CustomTooltip } from "@/components/common/customTooltip";
import { cn } from "../../lib/utils";

export type CustomLabelPropsType = {
  label?: string;
  labelClassName?: string;
  subLabelClassName?: string;
  subLabel?: string;
  labelTooltip?: string;
  icon?: React.ReactNode;
};

const CustomLabel = React.forwardRef<HTMLDivElement, CustomLabelPropsType>(
  (
    { label, labelClassName, subLabelClassName, subLabel, labelTooltip, icon },
    ref,
  ) => {
    // A trailing asterisk (required marker) is split from the text so that only
    // the text is truncated and the asterisk is always visible.
    const requiredMatch = label?.match(/^(.*?)\s*\*\s*$/);
    const labelText = requiredMatch ? requiredMatch[1] : label;
    const isRequired = Boolean(requiredMatch);

    return (
      <>
        {label && (
          <div className="flex gap-1 sm:mb-1 min-w-0 max-w-full" ref={ref}>
            <div className="flex flex-col justify-start min-w-0">
              <div className="flex items-center gap-2 min-w-0">
                {icon && (
                  <div className="text-gr-1 mb-[2px] shrink-0">{icon}</div>
                )}
                {label && (
                  <p
                    className={cn(
                      "flex min-w-0 whitespace-nowrap text-sm sm:text-xs font-medium text-gr-1",
                      labelClassName,
                    )}
                  >
                    <span className="truncate" title={labelText}>
                      {labelText}
                    </span>
                    {isRequired && <span className="shrink-0 pl-1">*</span>}
                  </p>
                )}
                {labelTooltip && (
                  <CustomTooltip iconClassName="h-3 w-3 text-gr-1 mb-[4px]">
                    {labelTooltip}
                  </CustomTooltip>
                )}
              </div>

              {subLabel && (
                <p className={cn("text-xs text-gray-400", subLabelClassName)}>
                  {subLabel}
                </p>
              )}
            </div>
          </div>
        )}
      </>
    );
  },
);

CustomLabel.displayName = "CustomLabel";

export { CustomLabel };
